module.exports = __webpack_public_path__ + "img/logo.774811b5.svg";